import stationsTimeline from "./stationsTimeline.component";

const stationsTimelineModule = angular
  .module("app.components.stationsTimeline", [])
  .component("stationsTimeline", stationsTimeline);

export default stationsTimelineModule;



// WEBPACK FOOTER //
// ./src/components/stationsTimeline/stationsTimeline.module.js